import {ValidationErrorKeys} from '@hconnect/common/consts'
import {removeMarkdownTags} from '@hconnect/common/utils'
import {type TFunction} from 'i18next'
import {object, string, date, array} from 'yup'

const DESCRIPTION_MAX_LENGTH = 5000

export const getOilAnalysisActionValidationSchema = ({t}: {t: TFunction}) =>
  object().shape({
    title: string().trim().required(t(ValidationErrorKeys.REQUIRED)),
    description: richTextFieldValidationSchema({t, max: DESCRIPTION_MAX_LENGTH}),
    plantUpmId: string().required(t(ValidationErrorKeys.REQUIRED)),
    functionalLocation: string().trim().nullable().notRequired(),
    processStage: string().trim().nullable().notRequired(),
    status: string().required(t(ValidationErrorKeys.REQUIRED)),
    priority: string().optional(),
    dueDate: date().required(t(ValidationErrorKeys.REQUIRED)),
    assignees: array().of(object()).notRequired()
  })

const richTextFieldValidationSchema = ({t, max}: {t: TFunction; max: number}) =>
  string()
    .trim()
    .required(t(ValidationErrorKeys.REQUIRED))
    .test('max-length-without-markdown', t(ValidationErrorKeys.MAX_LENGTH, {max}), (value) => {
      if (!value) return false
      const plainText = removeMarkdownTags(value)
      return plainText.length <= max
    })
